import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Databases from "@/pages/Databases";
import DatabaseDetail from "@/pages/DatabaseDetail";
import Docs from "@/pages/Docs";
import Backup from "@/pages/Backup";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-background" data-testid="auth-loading">
        <div className="h-8 w-8 border-2 border-zinc-700 border-t-orange-600 rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App noise">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Overview />} />
              <Route path="/databases" element={<Databases />} />
              <Route path="/databases/:name" element={<DatabaseDetail />} />
              <Route path="/backup" element={<Backup />} />
              <Route path="/docs" element={<Docs />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
